var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaturityGapActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/calculator"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41222 1.57922C3.52428 0.46716 5.18836 0.0419922 7.33333 0.0419922H10.6667C12.8116 0.0419922 14.4757 0.46716 15.5878 1.57922C16.6998 2.69127 17.125 4.35535 17.125 6.50033V11.5003C17.125 13.6453 16.6998 15.3094 15.5878 16.4214C14.4757 17.5335 12.8116 17.9587 10.6667 17.9587H7.33333C5.18836 17.9587 3.52428 17.5335 2.41222 16.4214C1.30017 15.3094 0.875 13.6453 0.875 11.5003V6.50033C0.875 4.35535 1.30017 2.69127 2.41222 1.57922ZM3.29611 2.4631C2.53317 3.22604 2.125 4.47864 2.125 6.50033V11.5003C2.125 13.522 2.53317 14.7746 3.29611 15.5376C4.05905 16.3005 5.31164 16.7087 7.33333 16.7087H10.6667C12.6884 16.7087 13.9409 16.3005 14.7039 15.5376C15.4668 14.7746 15.875 13.522 15.875 11.5003V6.50033C15.875 4.47864 15.4668 3.22604 14.7039 2.4631C13.9409 1.70016 12.6884 1.29199 10.6667 1.29199H7.33333C5.31164 1.29199 4.05905 1.70016 3.29611 2.4631Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 4.69238C6.15622 4.69238 5.875 4.97652 5.875 5.31738V6.15072C5.875 6.4945 6.15913 6.77572 6.5 6.77572H11.5C11.8438 6.77572 12.125 6.49158 12.125 6.15072V5.31738C12.125 4.97089 11.8465 4.69238 11.5 4.69238H6.5ZM4.625 5.31738C4.625 4.29158 5.46045 3.44238 6.5 3.44238H11.5C12.5368 3.44238 13.375 4.28054 13.375 5.31738V6.15072C13.375 7.17651 12.5396 8.02572 11.5 8.02572H6.5C5.4742 8.02572 4.625 7.19027 4.625 6.15072V5.31738Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94629 10.6673C4.94629 10.2071 5.31939 9.83398 5.77962 9.83398H5.78925C6.24949 9.83398 6.62258 10.2071 6.62258 10.6673C6.62258 11.1276 6.24949 11.5007 5.78925 11.5007H5.77962C5.31939 11.5007 4.94629 11.1276 4.94629 10.6673Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16309 10.6673C8.16309 10.2071 8.53618 9.83398 8.99642 9.83398H9.00605C9.46629 9.83398 9.83938 10.2071 9.83938 10.6673C9.83938 11.1276 9.46629 11.5007 9.00605 11.5007H8.99642C8.53618 11.5007 8.16309 11.1276 8.16309 10.6673Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3789 10.6673C11.3789 10.2071 11.752 9.83398 12.2122 9.83398H12.2219C12.6821 9.83398 13.0552 10.2071 13.0552 10.6673C13.0552 11.1276 12.6821 11.5007 12.2219 11.5007H12.2122C11.752 11.5007 11.3789 11.1276 11.3789 10.6673Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94629 13.5833C4.94629 13.1231 5.31939 12.75 5.77962 12.75H5.78925C6.24949 12.75 6.62258 13.1231 6.62258 13.5833C6.62258 14.0436 6.24949 14.4167 5.78925 14.4167H5.77962C5.31939 14.4167 4.94629 14.0436 4.94629 13.5833Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16309 13.5833C8.16309 13.1231 8.53618 12.75 8.99642 12.75H9.00605C9.46629 12.75 9.83938 13.1231 9.83938 13.5833C9.83938 14.0436 9.46629 14.4167 9.00605 14.4167H8.99642C8.53618 14.4167 8.16309 14.0436 8.16309 13.5833Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3789 13.5833C11.3789 13.1231 11.752 12.75 12.2122 12.75H12.2219C12.6821 12.75 13.0552 13.1231 13.0552 13.5833C13.0552 14.0436 12.6821 14.4167 12.2219 14.4167H12.2122C11.752 14.4167 11.3789 14.0436 11.3789 13.5833Z",
    fill: "#1DD899"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaturityGapActive);
export default __webpack_public_path__ + "static/media/maturityGapActive.3551b5e63548f284a2be381ade164bd5.svg";
export { ForwardRef as ReactComponent };